import React, { FC } from 'react'
import css from './selectWrapper.module.scss'

type SelectWrapperProps = {
  title?: string
  children: React.ReactNode
}

const SelectWrapper: FC<SelectWrapperProps> = ({ title, children }) => {
  return (
    <div className={css.wrapper}>
      {title ? (
        <label className={css.label}>
          <p className={css.title}>{title}</p>
          {children}
        </label>
      ) : (
        children
      )}
    </div>
  )
}

export default SelectWrapper
